import { Request } from '../';

/**
 * 消息摘要
 * @param payload
 * @returns {Promise<*>}
 */
export const msgUser = async payload => {
  const query = `query msgUser {
  me {
    detail {
      nickname
      verifyFriend
      findByUsername
      findByPhone
      findByEmail
      unread
      unreadTiny
      allowAnonymous
      allowAutoContact
      friendApplyNum
    }
  }
}`;
  return (await Request.request(query, payload, 'msg', '消息摘要')).me.detail;
};

/**
 * 消息列表
 * @returns {Promise<*>}
 */
export const queryMessageList = async params => {
  const gql = `query messageList($userId: FormUserId, $query: FormQuery) {
  me {
    messageList(userId: $userId, query: $query) {
      data {
        mid
        uid
        uidTo
        roomId
        fromId
        relId
        cid
        createTime
        isMe
        isRead
        content
        msgType
        extType
      }
      meta {
        limit
        page
        count
        num
      }
    }
  }
}`;
  return (await Request.request(gql, params, 'msg', '消息列表')).me.messageList;
};

/**
 * 最近会话
 * @param params
 * @returns {Promise<*>}
 */
export const queryRecentList = async params => {
  const gql = `query recentList($query: FormQuery) {
  me {
    recentList(query: $query) {
      data{
        tid
        roomId
        cid
        name
        nameAlias
        lastMsg
        lastTime
        unread
        isLastMe
        isRead
        priority
        readSelf
        readTarget
        tidFrom
        icon
      }
      meta {
        limit
        page
        count
        num
      }
    }
  }
}`;
  return (await Request.request(gql, params, 'msg', '最近会话')).me.recentList;
};

/**
 * 标记某条最近会话已读
 * @param params
 * @returns {Promise<*>}
 */
export const recentMark = async params => {
  const gql = `mutation recentMark($tid: String!, $readSelf: String) {
    meExec {
      recentMark(tid: $tid, readSelf: $readSelf)
    }
  }`;
  return (await Request.request(gql, params, 'msg', '标记最近会话已读')).meExec.recentMark;
};

/**
 * 发送消息
 * @param params
 * @returns {Promise<*>}
 */
export const messageNew = async params => {
  const gql = `mutation newMsg($form: FormMessage!) {
  meExec {
    messageNew(form: $form) {
      mid
      cid
      data {
        roomId
        fromId
        createTime
        isMe
        content
      }
    }
  }
}`;
  return (await Request.request(gql, params, 'msg', '发送消息')).meExec.messageNew;
};

/**
 * 新建会话
 * @param params
 * @returns {Promise<*>}
 */
export const recentNew = async params => {
  const gql = `mutation recentNew($tid: String!) {
  meExec {
    recentNew(tid: $tid) {
      roomId
      tid
      name
      cid
      nameAlias
      isLastMe
    }
  }
}`;
  return (await Request.request(gql, params, 'msg', '发送消息')).meExec.recentNew;
};
